export default {
    restrict: 'A',
    template: '',
    link: () => {}
};
